import { useNavigate } from 'react-router-dom'
import { useReselector } from '@/utils/sharedHooks'
import { Card, Text, Button, CardColors } from '@/ui'
import { TypographyStyles } from '@/styles'

import { selectCurrentAnnualTaxYear } from '@/featuresV1/Admin/AnnualTaxDetails/annualTaxDetails.selector'

export const EoyPromptCard = () => {
  const navigate = useNavigate()
  const year = useReselector(selectCurrentAnnualTaxYear)

  return (
    <Card color={CardColors.LEVEL_1}>
      <div className="grid grid-cols-1 lg:grid-cols-12 items-start gap-4">
        <div className="lg:col-span-9 space-y-2">
          <Text variant={TypographyStyles.H2}>
            Complete your {year} End-of-Year Review
          </Text>
          <Text variant={TypographyStyles.BODY_MD}>
            Take some time to review your {year} transactions and relevant
            information.
          </Text>
        </div>
        <Button
          className="lg:col-span-3 flex justify-end items-center mt-4 lg:mt-0"
          onClick={() => navigate('/taxes/annual')}
        >
          Get Started
        </Button>
      </div>
    </Card>
  )
}
